var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input-frame",
    {
      staticClass: "q-chips-input",
      attrs: {
        focused: _vm.focused,
        length: _vm.length,
        "additional-length": _vm.input.length > 0
      },
      on: { click: _vm.__onClick }
    },
    [
      _c(
        "div",
        { staticClass: "col row items-center group q-input-chips" },
        [
          _vm._l(_vm.model, function(customer, index) {
            return _c(
              "q-chip",
              {
                key: customer.id,
                attrs: { small: "", closable: "", "text-color": "grey-8" },
                on: {
                  hide: function($event) {
                    _vm.remove(index)
                  }
                }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.getCustomerName(customer)) + "\n    "
                )
              ]
            )
          }),
          _vm.$attrs.type === "checkbox"
            ? _c(
                "input",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input,
                        expression: "input"
                      }
                    ],
                    ref: "input",
                    staticClass: "col q-input-target",
                    attrs: { placeholder: _vm.placeholder, type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.input)
                        ? _vm._i(_vm.input, null) > -1
                        : _vm.input
                    },
                    on: {
                      focus: _vm.__onFocus,
                      blur: _vm.__onInputBlur,
                      keydown: _vm.__handleKeyDown,
                      keyup: _vm.__onKeyup,
                      change: function($event) {
                        var $$a = _vm.input,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.input = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.input = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.input = $$c
                        }
                      }
                    }
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.$attrs.type === "radio"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input,
                          expression: "input"
                        }
                      ],
                      ref: "input",
                      staticClass: "col q-input-target",
                      attrs: { placeholder: _vm.placeholder, type: "radio" },
                      domProps: { checked: _vm._q(_vm.input, null) },
                      on: {
                        focus: _vm.__onFocus,
                        blur: _vm.__onInputBlur,
                        keydown: _vm.__handleKeyDown,
                        keyup: _vm.__onKeyup,
                        change: function($event) {
                          _vm.input = null
                        }
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input,
                          expression: "input"
                        }
                      ],
                      ref: "input",
                      staticClass: "col q-input-target",
                      attrs: {
                        placeholder: _vm.placeholder,
                        type: _vm.$attrs.type
                      },
                      domProps: { value: _vm.input },
                      on: {
                        focus: _vm.__onFocus,
                        blur: _vm.__onInputBlur,
                        keydown: _vm.__handleKeyDown,
                        keyup: _vm.__onKeyup,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.input = $event.target.value
                        }
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
        ],
        2
      ),
      _vm.isLoading
        ? _c("q-spinner", {
            staticClass: "q-if-control",
            attrs: { slot: "after", size: "24px" },
            slot: "after"
          })
        : _vm._e(),
      _c("infinite-autocomplete", {
        ref: "autocomplete",
        attrs: {
          debounce: _vm.defaultSearchDebounce,
          "min-characters": 0,
          "max-results": 200,
          "max-height": "300px"
        },
        on: {
          fetch: _vm.handleInfiniteScroll,
          search: _vm.handleSearch,
          selected: _vm.handleSelected
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }